import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import {
  convertLoopToIcx,
  round,
  convertHexToDecimal,
  formatNumber,
} from '../utils/Conversions';

import { useIconSwapService } from './IconSwapService';

import TAP from '../images/TAP.svg';
import AC3 from '../images/ac3.svg';
import SPORTS from '../images/sports.svg';
import WOK from '../images/weblok.svg';
import ICX from '../images/ICX.png';
import noTransactionPrice from '../images/NoTransactionsPrice.png';

const swapTypes = {
  AC3: 'cx9ab3078e72c8d9017194d17b34b1a47b661945ca',
  SPORTS: 'cx08eb683a53d6f244d538a45f0cc584825e2cb985',
  TAP: 'cxc0b5b52c9f8b4251a47e91dda3bd61e5512cd782',
  WOK: 'cx921205acb7c51e16d5b7cbc37539a4357d929d20',
  ICX: 'cx0000000000000000000000000000000000000000',
};

export const SwappingPanel = ({ swapType, direction }: SwappingPanelTypes) => {
  const {
    getMarketBuyersPendingSwaps,
    getMarketSellersPendingSwaps,
    tokens,
  } = useIconSwapService();
  const [marketBuyersSwaps, setMarketBuyersSwaps] = useState([]);
  const [marketSellersSwaps, setMarketSellersSwaps] = useState([]);
  const [tokensObject, setTokensObject] = useState({});
  const [hoverComponent, setHoverComponent] = useState<string>();

  useEffect(() => {
    const getPendingBuyerSwaps = async (maker: string, taker: string) => {
      // @ts-ignore
      const swaps = await getMarketBuyersPendingSwaps(maker, taker);
      setMarketBuyersSwaps(swaps);
    };

    const getPendingSellerSwaps = async (maker?: any, taker?: any) => {
      // @ts-ignore
      const swaps = await getMarketSellersPendingSwaps(maker, taker);
      setMarketSellersSwaps(swaps);
    };

    if (direction === 'from') {
      // @ts-ignore
      getPendingBuyerSwaps(swapTypes.ICX, swapTypes[swapType]);
    } else {
      // @ts-ignore
      getPendingSellerSwaps(swapTypes[swapType], swapTypes.ICX);
    }
  }, [swapType]);

  useEffect(() => {
    getWindowDimensions();
    setTokensObject(tokens);
  }, [tokens]);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const { innerWidth: width } = window;

  const calculateSwapPrice = (
    makerAmount: string,
    makerToken: string,
    takerAmount: string,
    takerToken: string
  ) => {
    const convertedMaker = convertLoopToIcx(makerAmount);
    const convertedTaker = convertLoopToIcx(takerAmount);
    if (makerToken === 'cx0000000000000000000000000000000000000000') {
      const price = convertedMaker / convertedTaker;
      const roundedPrice = round(price, 5);
      return roundedPrice;
    }
    if (takerToken === 'cx0000000000000000000000000000000000000000') {
      const price = convertedTaker / convertedMaker;
      const roundedPrice = round(price, 5);
      return roundedPrice;
    }
  };

  const renderICXForSwaps = () => {
    // if (marketBuyersSwaps.length === 0) {
    //   return;
    // }

    if (marketSellersSwaps.length > 0) {
      return marketSellersSwaps.map((swap: any) => {
        if (!tokens) return 0;
        const tokensArray = Object.entries(tokens);
        tokensArray.map((token) => {
          if (swap.maker.contract === token[0]) {
            swap.makerToken = token[1];
          }
          if (swap.taker.contract === token[0]) {
            swap.takerToken = token[1];
          }
        });
        return hoverComponent === swap.id && width > 414 ? (
          <Link
            to={`/makeSwap/${
              swap.makerToken.symbol !== 'ICX'
                ? swap.makerToken.symbol
                : swap.takerToken.symbol
            }/${convertHexToDecimal(swap.id)}`}
            style={{ textDecoration: 'none' }}
            key={swap.id}
          >
            <TableRowOnHover
              key={swap.id}
              onMouseLeave={() => setHoverComponent('')}
            >
              <SellingColumn>
                <SellingColumnText>
                  {formatNumber(round(convertLoopToIcx(swap.taker.amount), 5))}{' '}
                  {
                    // @ts-ignore
                    tokensObject && tokensObject[swap.taker.contract]?.symbol
                  }
                </SellingColumnText>
              </SellingColumn>
              <BuyingColumn>
                <BuyingColumnText>
                  {formatNumber(round(convertLoopToIcx(swap.maker.amount), 5))}{' '}
                  {
                    // @ts-ignore
                    tokensObject && tokensObject[swap.maker.contract]?.symbol
                  }
                </BuyingColumnText>
              </BuyingColumn>
              <PriceColumn>
                <PriceColumnText>
                  {calculateSwapPrice(
                    swap.taker.amount,
                    swap.taker.contract,
                    swap.maker.amount,
                    swap.maker.contract
                  )}
                </PriceColumnText>
              </PriceColumn>
            </TableRowOnHover>
          </Link>
        ) : (
          <Link
            to={`/makeSwap/${
              swap.makerToken.symbol !== 'ICX'
                ? swap.makerToken.symbol
                : swap.takerToken.symbol
            }/${convertHexToDecimal(swap.id)}`}
            style={{ textDecoration: 'none' }}
            key={swap.id}
          >
            <TableRow
              onMouseEnter={() => setHoverComponent(swap.id)}
              key={swap.id}
            >
              <SellingColumn>
                <SellingColumnText>
                  {formatNumber(round(convertLoopToIcx(swap.taker.amount), 5))}{' '}
                  {
                    // @ts-ignore
                    tokensObject && tokensObject[swap.taker.contract]?.symbol
                  }
                </SellingColumnText>
              </SellingColumn>
              <BuyingColumn>
                <BuyingColumnText>
                  {formatNumber(round(convertLoopToIcx(swap.maker.amount), 5))}{' '}
                  {
                    // @ts-ignore
                    tokensObject && tokensObject[swap.maker.contract]?.symbol
                  }
                </BuyingColumnText>
              </BuyingColumn>
              <PriceColumn>
                <PriceColumnText>
                  {calculateSwapPrice(
                    swap.taker.amount,
                    swap.taker.contract,
                    swap.maker.amount,
                    swap.maker.contract
                  )}
                </PriceColumnText>
              </PriceColumn>
            </TableRow>
          </Link>
        );
      });
    } else if (marketBuyersSwaps.length > 0) {
      return marketBuyersSwaps.map((swap: any) => {
        if (!tokens) return 0;
        const tokensArray = Object.entries(tokens);
        tokensArray.map((token) => {
          if (swap.maker.contract === token[0]) {
            swap.makerToken = token[1];
          }
          if (swap.taker.contract === token[0]) {
            swap.takerToken = token[1];
          }
        });
        return hoverComponent === swap.id ? (
          <Link
            to={`/makeSwap/${
              swap.makerToken.symbol !== 'ICX'
                ? swap.makerToken.symbol
                : swap.takerToken.symbol
            }/${convertHexToDecimal(swap.id)}`}
            style={{ textDecoration: 'none' }}
            key={swap.id}
          >
            <TableRowOnHover
              key={swap.id}
              onMouseLeave={() => setHoverComponent('')}
            >
              <SellingColumn>
                <SellingColumnText>
                  {formatNumber(round(convertLoopToIcx(swap.taker.amount), 5))}{' '}
                  {
                    // @ts-ignore
                    tokensObject && tokensObject[swap.taker.contract]?.symbol
                  }
                </SellingColumnText>
              </SellingColumn>
              <BuyingColumn>
                <BuyingColumnText>
                  {formatNumber(round(convertLoopToIcx(swap.maker.amount), 5))}{' '}
                  {
                    // @ts-ignore
                    tokensObject && tokensObject[swap.maker.contract]?.symbol
                  }
                </BuyingColumnText>
              </BuyingColumn>
              <PriceColumn>
                <PriceColumnText>
                  {calculateSwapPrice(
                    swap.taker.amount,
                    swap.taker.contract,
                    swap.maker.amount,
                    swap.maker.contract
                  )}
                </PriceColumnText>
              </PriceColumn>
            </TableRowOnHover>
          </Link>
        ) : (
          <Link
            to={`/makeSwap/${
              swap.makerToken.symbol !== 'ICX'
                ? swap.makerToken.symbol
                : swap.takerToken.symbol
            }/${convertHexToDecimal(swap.id)}`}
            style={{ textDecoration: 'none' }}
            key={swap.id}
          >
            <TableRow
              onMouseEnter={() => setHoverComponent(swap.id)}
              key={swap.id}
            >
              <SellingColumn>
                <SellingColumnText>
                  {formatNumber(round(convertLoopToIcx(swap.taker.amount), 5))}{' '}
                  {
                    // @ts-ignore
                    tokensObject && tokensObject[swap.taker.contract]?.symbol
                  }
                </SellingColumnText>
              </SellingColumn>
              <BuyingColumn>
                <BuyingColumnText>
                  {formatNumber(round(convertLoopToIcx(swap.maker.amount), 5))}{' '}
                  {
                    // @ts-ignore
                    tokensObject && tokensObject[swap.maker.contract]?.symbol
                  }
                </BuyingColumnText>
              </BuyingColumn>
              <PriceColumn>
                <PriceColumnText>
                  {calculateSwapPrice(
                    swap.taker.amount,
                    swap.taker.contract,
                    swap.maker.amount,
                    swap.maker.contract
                  )}
                </PriceColumnText>
              </PriceColumn>
            </TableRow>
          </Link>
        );
      });
    } else {
      return (
        <NonePendingWrapper>
          <NonePendingTableRow>
            <NonePendingAmountImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingBuyingImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingPriceImage
              src={noTransactionPrice}
              alt="none pending"
            />
          </NonePendingTableRow>
          <NonePendingTableRow>
            <NonePendingAmountImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingBuyingImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingPriceImage
              src={noTransactionPrice}
              alt="none pending"
            />
          </NonePendingTableRow>
          <NonePendingTableRow>
            <NonePendingAmountImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingBuyingImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingPriceImage
              src={noTransactionPrice}
              alt="none pending"
            />
          </NonePendingTableRow>
          <NonePendingTableRow>
            <NonePendingAmountImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingBuyingImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingPriceImage
              src={noTransactionPrice}
              alt="none pending"
            />
          </NonePendingTableRow>
          <NonePendingTableRow>
            <NonePendingAmountImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingBuyingImage
              src={noTransactionPrice}
              alt="none pending"
            />
            <NonePendingPriceImage
              src={noTransactionPrice}
              alt="none pending"
            />
          </NonePendingTableRow>
        </NonePendingWrapper>
      );
    }
  };

  const showIcon = (type?: string) => {
    switch (type) {
      case 'AC3':
        return AC3;
      case 'SPORTS':
        return SPORTS;
      case 'WOK':
        return WOK;
      case 'TAP':
        return TAP;
      default:
        return ICX;
    }
  };

  return (
    <ComponentWrapper>
      <TitleWrapper>
        <Icon
          src={direction === 'from' ? showIcon() : showIcon(swapType)}
          alt="token"
        />
        <TitleText>
          Swapping {direction === 'from' ? 'ICX' : swapType} for{' '}
          {direction === 'to' ? 'ICX' : swapType}
        </TitleText>
      </TitleWrapper>
      <TableHeader>
        <SellingText>Selling</SellingText>
        <BuyingText>Buying</BuyingText>
        <PriceText>Price (ICX)</PriceText>
      </TableHeader>
      <TableBody>{renderICXForSwaps()}</TableBody>
    </ComponentWrapper>
  );
};

export default SwappingPanel;

const ComponentWrapper = styled.div`
  background-color: #fff;
  width: 508px;
  min-width: 508px;
  height: 532px;
  box-shadow: 2px 2px 6px 2px #e9ebec;
  border-radius: 5px;
  border-color: #e9ebec;
  border-style: solid;
  border-width: 0.5px;
  @media (max-width: 414px) {
    width: 335px;
    min-width: 335px;
  }
`;

const TitleWrapper = styled.div`
  margin-top: 28px;
  margin-left: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 414px) {
    margin-top: 20px;
    margin-left: 20px;
  }
`;

const Icon = styled.img`
  height: 50px;
  width: 50px;
  @media (max-width: 414px) {
    height: 30px;
    width: 30px;
  }
`;

const TitleText = styled.span`
  padding-left: 10px;
  color: #0e0d0e;
  font-family: 'Avenir Next';
  font-size: 26px;
  font-weight: 600;
  @media (max-width: 414px) {
    color: #070707;
    font-size: 19px;
  }
`;

const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-top: 12px;
  padding-bottom: 18px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #e9ebec;
`;

const SellingText = styled.span``;

const BuyingText = styled.span``;

const PriceText = styled.span``;

const TableBody = styled.div`
  padding-left: 30px;
  padding-right: 30px;
  height: 390px;
  overflow: scroll;
  @media (max-width: 414px) {
    padding: 0;
  }
`;

const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom-color: #e9ebec;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  height: 58px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 414px) {
    width: 330px;
    flex-direction: row;
  }
`;

const NonePendingTableRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom-color: #e9ebec;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  height: 58px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 414px) {
    width: 300px;
    flex-direction: row;
  }
`;

const TableRowOnHover = styled.div`
  border-bottom-color: #e9ebec;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  height: 59px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 2px 2px 6px 2px #e9ebec;
  border-radius: 5px;
`;

const SellingColumn = styled.div`
  width: 148px;
  margin-left: 25px;
  @media (max-width: 414px) {
    width: 100px;
    margin: 0;
    margin-left: 20px;
  }
`;

const SellingColumnText = styled.span`
  width: 85px;
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 500;
  text-align: left;
`;

const BuyingColumn = styled.div`
  width: 148px;
  display: flex;
  margin-left: 35px;
  @media (max-width: 414px) {
    width: 120px;
  }
`;

const BuyingColumnText = styled.span`
  text-align: right;
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  @media (max-width: 414px) {
    margin-right: 0px;
    margin-left: 10px;
  }
`;

const PriceColumn = styled.div`
  width: 128px;
  display: flex;
  margin-left: 40px;
  @media (max-width: 414px) {
    width: 110px;
    margin-right: 0;
  }
`;

const PriceColumnText = styled.span`
  text-align: right;
  margin-right: 15px;
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 500;
  text-align: right;
  @media (max-width: 414px) {
    margin-right: 25px;
  }
`;

const SecondRowWrapper = styled.div`
  @media (max-width: 414px) {
    display: flex;
    flex-direction: row;
  }
`;

const NonePendingWrapper = styled.div`
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const NonePendingBuyingImage = styled.img`
  height: 16px;
  width: 53px;
  @media (max-width: 414px) {
    height: 30px;
    margin-bottom: 10px;
    width: 50px;
  }
`;

const NonePendingPriceImage = styled.img`
  height: 16px;
  width: 53px;
  margin-right: 50px;
  @media (max-width: 414px) {
    width: 207px;
    margin-left: 0;
    width: 80px;
  }
`;

const NonePendingAmountImage = styled.img`
  height: 16px;
  width: 53px;
  margin-left: 20px;
  @media (max-width: 414px) {
    margin-left: 0;
    width: 80px;
  }
`;

type SwappingPanelTypes = {
  swapType: string;
  direction: string;
};
